export class Oauth2TokenResponse {
    'accessToken';
    'tokenType';
    'refreshToken';
    'expiresIn';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "accessToken",
            "baseName": "access_token",
            "type": "string",
            "format": ""
        },
        {
            "name": "tokenType",
            "baseName": "token_type",
            "type": "string",
            "format": ""
        },
        {
            "name": "refreshToken",
            "baseName": "refresh_token",
            "type": "string",
            "format": ""
        },
        {
            "name": "expiresIn",
            "baseName": "expires_in",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Oauth2TokenResponse.attributeTypeMap;
    }
    constructor() {
    }
}
